const boardroom = {
  selectAdvisors: "בחר יועצים",
  quickSelect: "בחירה מהירה",
  presetAll: "⚡ כולם",
  presetBusiness: "🏛️ עסקי",
  presetTechnical: "💻 טכני",
  readyQuestions: "שאלות מוכנות",
  selectAndAsk: "בחר יועצים ושאל שאלה",
  advisorsSelected: "יועצים נבחרו",
  advisors: "יועצים",
  newQuestion: "שאלה חדשה",
  askPlaceholder: "שאל את",
  toSend: "לשליחה",
  newLine: "לשורה חדשה",
  send: "שאל",
  responses: "תשובות",
  thinking: "חושב...",
} as const;
export default boardroom;
